/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchAutcompleteSuggestion
 */
export interface SearchAutcompleteSuggestion {
    /**
     * サジェスト順番
     * @type {number}
     * @memberof SearchAutcompleteSuggestion
     */
    order: number;
    /**
     * サジェスト値
     * @type {string}
     * @memberof SearchAutcompleteSuggestion
     */
    keyword: string;
}

export function SearchAutcompleteSuggestionFromJSON(json: any): SearchAutcompleteSuggestion {
    return SearchAutcompleteSuggestionFromJSONTyped(json, false);
}

export function SearchAutcompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchAutcompleteSuggestion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'order': json['order'],
        'keyword': json['keyword'],
    };
}

export function SearchAutcompleteSuggestionToJSON(value?: SearchAutcompleteSuggestion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'order': value.order,
        'keyword': value.keyword,
    };
}

